
console.log( `%c
██ ▄█▀ ██░ ██  
██▄█▒ ▓██░ ██▒ 
▓███▄░ ▒██▀▀██░
▓██ █▄ ░▓█ ░██ 
▒██▒ █▄░▓█▒░██▓
▒ ▒▒ ▓▒ ▒ ░░▒░▒
░ ░▒ ▒░ ▒ ░▒░ ░
░ ░░ ░  ░  ░░ ░
░  ░    ░  ░  ░
                             
Developed By Kenner Hernandez `, 'font-weight:700;color:#f5f5f5;' )

